import { render, staticRenderFns } from "./resources-detail.vue?vue&type=template&id=4debc542&"
import script from "./resources-detail.vue?vue&type=script&lang=js&"
export * from "./resources-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports